import React from 'react';

import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { HintText } from 'components/HintText/HintText';
import { HINTTEXT_TYPE } from 'components/HintText/HintTextType';

import { FFormDebug } from 'utils/FFormDebug';

export const EventRegisterFormFooter = ({
  actionTitle,
  actionDisabled,
  actionType,
  onAction,
  cancelAllTitle,
  onCancelAll,
  cancelAllDisabled,
  remainingAllowed,
  guestNotAllowedError,
  values,
  errors,
  touched,
}) => {
  return (
    <>
      <div className="event-register-form__submit-button-wrapper">
        <ActionButton
          title={actionTitle}
          type={actionType}
          onClick={onAction}
          disabled={actionDisabled}
          inverted
        />
        {cancelAllTitle && onCancelAll && (
          <ActionButton
            title={cancelAllTitle}
            type="button"
            onClick={onCancelAll}
            disabled={cancelAllDisabled}
            inverted
          />
        )}
      </div>

      {remainingAllowed && (
        <div className="event-register-form__booked-out-text">
          <HintText type={HINTTEXT_TYPE.ERROR}>
            {remainingAllowed === 0
              ? 'Ups, da war wohl jemand Anderes schneller. Die Veranstaltung ist leider ausgebucht.'
              : `Ups, da war wohl jemand Anderes schneller. Die restliche freie Teilnehmerzahl  beträgt leider nur noch ${remainingAllowed} Teilnehmer. Bitte reduzieren Sie Ihre Teilnehmeranzahl entsprechend.`}
          </HintText>
        </div>
      )}
      {guestNotAllowedError && (
        <div className="event-register-form__booked-out-text">
          <HintText type={HINTTEXT_TYPE.ERROR}>
            Für diese Veranstaltung können keine Gäste angemeldet werden. Bitte entfernen Sie alle
            Gäste aus der Teilnehmerliste.
          </HintText>
        </div>
      )}
      <div className="event-register-form__mandantory-fields-description">
        Mit * gekennzeichnete Felder sind Pflichtfelder
      </div>
      <FFormDebug values={values} errors={errors} touched={touched} />
    </>
  );
};

EventRegisterFormFooter.propTypes = {
  actionTitle: PropTypes.string.isRequired,
  actionDisabled: PropTypes.bool.isRequired,
  actionType: PropTypes.oneOf(['submit', 'button']).isRequired,
  onAction: PropTypes.func,
  cancelAllTitle: PropTypes.string,
  onCancelAll: PropTypes.func,
  cancelAllDisabled: PropTypes.bool,
  remainingAllowed: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  guestNotAllowedError: PropTypes.bool,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
};

EventRegisterFormFooter.defaultProps = {
  onAction: undefined,
  cancelAllTitle: undefined,
  onCancelAll: undefined,
  cancelAllDisabled: false,
  remainingAllowed: null,
  guestNotAllowedError: false,
};
